import { render, staticRenderFns } from "./create-tag-group.vue?vue&type=template&id=2cf711e3&scoped=true"
import script from "./create-tag-group.vue?vue&type=script&lang=js"
export * from "./create-tag-group.vue?vue&type=script&lang=js"
import style0 from "./create-tag-group.vue?vue&type=style&index=0&id=2cf711e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf711e3",
  null
  
)

export default component.exports